// ===== 站点备案信息（合规展示）=====
// 工信部要求：已备案网站的首页底部必须展示 ICP 备案号，并设置为可点击链接跳转到工信部备案查询系统。
// 公安联网备案通过后，还需追加公安备案号 + 官方徽标，链接到全国互联网安全管理服务平台。
//
// ⚠️ 只在正式备案域名下展示：香港旧站（www.changfaxianghang.cc.cd）没有 ICP 备案，
// 若一并显示会造成「备案号与当前域名不符」，反而构成合规风险。

/** ICP 备案号，例如「粤ICP备2026XXXXXX号-1」（通信管理局审核通过后下发） */
export const ICP_BEIAN = '粤ICP备2026114533号';

/** 公安联网备案号，例如「粤公网安备441900XXXXXXXX号」（公安备案通过后再填） */
export const POLICE_BEIAN = '粤公网安备44198102000144号';

export const ICP_BEIAN_URL = 'https://beian.miit.gov.cn/';
export const POLICE_BEIAN_URL = 'https://beian.mps.gov.cn/';

/** 已备案的正式域名（含其子域） */
const FILED_HOSTS = ['changfaxianghang.top'];

function currentHostname(): string {
  return typeof window !== 'undefined' ? window.location?.hostname || '' : '';
}

/** 当前访问的域名是否属于已备案域名 —— 决定是否展示备案信息 */
export function onFiledDomain(hostname: string = currentHostname()): boolean {
  const h = hostname.toLowerCase();
  return FILED_HOSTS.some((d) => h === d || h.endsWith(`.${d}`));
}

/** 是否已填写任何备案号 */
export function hasBeianInfo(): boolean {
  return Boolean(ICP_BEIAN || POLICE_BEIAN);
}

/** 是否应当在页脚展示备案栏 */
export function shouldShowBeian(hostname?: string): boolean {
  return onFiledDomain(hostname) && hasBeianInfo();
}
